var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00039 6.6749C5.88372 6.6749 5.77139 6.6539 5.66339 6.6119C5.55472 6.57057 5.45872 6.50824 5.37539 6.4249L0.875391 1.9249C0.725391 1.7749 0.650391 1.5999 0.650391 1.3999C0.650391 1.1999 0.725391 1.0249 0.875391 0.874903C1.02539 0.724903 1.20039 0.649902 1.40039 0.649902C1.60039 0.649902 1.77539 0.724903 1.92539 0.874903L6.00039 4.9499L10.0754 0.874903C10.2254 0.724903 10.4004 0.649902 10.6004 0.649902C10.8004 0.649902 10.9754 0.724903 11.1254 0.874903C11.2754 1.0249 11.3504 1.1999 11.3504 1.3999C11.3504 1.5999 11.2754 1.7749 11.1254 1.9249L6.62539 6.4249C6.54206 6.50824 6.44639 6.57057 6.33839 6.6119C6.22972 6.6539 6.11706 6.6749 6.00039 6.6749Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.ac0ea8a8f26c94b6fce5fc1d632ac57b.svg";
export { ForwardRef as ReactComponent };